export default __webpack_public_path__ + "static/media/tripple-arrow.29f5230f.svg";